import { SupportPanelState } from '@/layouts/UnityLayout'
import { Templates } from './Templates'
import { Faq } from './Faq'
import { DataAssets } from './DataAssets'
import { Glossary } from './Glossary'

export function SupportPanelComponentRenderer({ supportPanelView, setSupportPanelView }: SupportPanelState) {
  console.log(supportPanelView)
  switch (supportPanelView?.key) {
    case 'data-assets':
      return <DataAssets supportPanelView={supportPanelView} setSupportPanelView={setSupportPanelView} />
    case 'data-templates':
      return <Templates supportPanelView={supportPanelView} setSupportPanelView={setSupportPanelView} />
    case 'glossary':
      return <Glossary supportPanelView={supportPanelView} setSupportPanelView={setSupportPanelView} />
    case 'faq':
      return <Faq supportPanelView={supportPanelView} setSupportPanelView={setSupportPanelView} />
    default:
      return <div>Support Pane Key not supported</div>
  }
}
